import { buildAdUnitRequest } from "@common";
import { Action } from "redux";
import { FETCH_STATE_INITIAL } from "rd-redux-http";
import { CleanAdUnitBuilderAssetAction } from "../actions";

export function adUnitBuildingReducer(
    state: typeof buildAdUnitRequest.types.reduxState,
    action: Action
): typeof buildAdUnitRequest.types.reduxState {
    if (buildAdUnitRequest.actions.isMy(action)) {
        return buildAdUnitRequest.reducer(state, action);
    }

    if (CleanAdUnitBuilderAssetAction.is(action)) {
        return { fetchState: FETCH_STATE_INITIAL };
    }

    return state;
}
